<template>
    <div class="login-container">
        <div id="cognito-signin-container" :style="{ visibility: ready ? 'visible' : 'hidden' }"></div>
<!--
        <LoginContent page-name="Login"/>
-->        
    </div>
</template>

<script>
import { userManager } from "../aws";
//import LoginContent from "../views/LoginContent.vue";

export default {
  name: "LoginCognito",
  components: {
   // LoginContent
  },
  data() {
        return {
      ready: false,
    };
  },

  created() {},

  mounted() {
    document.body.classList.add("admin-layout-scoped-for-login");

    // Automatically redirect to Cognito login on page load
    this.signIn();
  },

  methods: {
    async signIn() {
      await userManager.signinRedirect();
    }
  }
};
</script>

<style scoped>
</style>
